/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [
	  //图表
	  {
		path: '/charts',
		name:'charts',
		meta:{requireAuth: true},
		component: () => import('./views/Charts.vue'),
	  },
	  {
	  	path: '/hotel',
	  	name:'hotel',
	  	meta:{requireAuth: true},
	  	component: () => import('./views/Hotel.vue'),
	  }, 
	  {
	  	path: '/report',
	  	name:'report',
	  	meta:{requireAuth: true},
	  	component: () => import('./views/Report.vue'),
	  },
	  {
	  	path: '/group',
	  	name:'group',
	  	meta:{requireAuth: true},
	  	component: () => import('./views/Group.vue'),
	  }, 
	
      {
        path: '/',
		redirect: '/home',
        component: () => import('./layouts/main/Main.vue'),
        children: [
          {
            path: '/home',
            name: 'home',
   		   meta:{requireAuth: true},
            component: () => import('./views/Home.vue'),
          },
		  {
		      path: '/home/analytics',
		      name: 'homeAnalytics',
		      component: () => import('./views/HomeAnalytics.vue'),
		      meta:{requireAuth: true},
		  },
		  {
		      path: '/home/ecommerce',
		      name: 'homeCommerce',
		      component: () => import('./views/HomeCommerce.vue'),
		      meta:{requireAuth: true},
		  },
          {
            path: '/page2',
            name: 'page2',
			meta:{requireAuth: true},
            component: () => import('./views/Page2.vue')
          },
        ],
      },
	  //用户模块
	  {
	    path: '/user',
	  	redirect: '/user/myuser',
	    component: () => import('./layouts/main/Main.vue'),
	    children: [
			  {
				path: '/user/myuser',
				name: 'myuser',
				meta:{requireAuth: true},
				component: () => import('./views/pages/user/Myuser.vue'),
			  },
	  		  {
	  		      path: '/user/myculture',
	  		      name: 'myculture',
	  		      component: () => import('./views/pages/user/Myculture.vue'),
	  		      meta:{requireAuth: true},
	  		  },
	  		  {
	  		      path: '/user/myrecords',
	  		      name: 'myrecords',
	  		      component: () => import('./views/pages/user/Myrecords.vue'),
	  		      meta:{requireAuth: true},
	  		  },
	    ],
	  },
	  {
	  	path: '/user/myculturedetails',
	  	name: 'myculturedetails',
	  	meta:{requireAuth: true},
	  	component: () => import('./views/pages/user/Myculturedetails.vue'),
	  },
	  {
	  	path: '/user/myrecorddetails',
	  	name: 'myrecorddetails',
	  	meta:{requireAuth: true},
	  	component: () => import('./views/pages/user/Myrecorddetails.vue'),
	  },
	  
	  
	  //管理模块
	  {
	    path: '/admin',
	  	redirect: '/admin/reviewed',
	    component: () => import('./layouts/main/Main.vue'),
	    children: [
			  {
				path: '/admin/reviewed',
				name: 'reviewed',
				meta:{requireAuth: true},
				component: () => import('./views/pages/admin/Reviewed.vue'),
			  },
			  {
			  	path: '/admin/unsubmit',
			  	name: 'unsubmit',
			  	meta:{requireAuth: true},
			  	component: () => import('./views/pages/admin/Unsubmit.vue'),
			  },
	  		  {
	  		  	path: '/admin/scored',
	  		  	name: 'scored',
	  		  	meta:{requireAuth: true},
	  		  	component: () => import('./views/pages/admin/Scored.vue'),
	  		  },
			  {
			  	path: '/admin/notes',
			  	name: 'notes',
			  	meta:{requireAuth: true},
			  	component: () => import('./views/pages/admin/Notes.vue'),
			  },
			  {
			  	path: '/admin/history',
			  	name: 'history',
			  	meta:{requireAuth: true},
			  	component: () => import('./views/pages/admin/History.vue'),
			  },
	  		  {
	  		  	path: '/admin/configure',
	  		  	name: 'configure',
	  		  	meta:{requireAuth: true},
	  		  	component: () => import('./views/pages/admin/Configure.vue'),
	  		  },
			  {
				path: '/admin/organization',
				name: 'organization',
				meta:{requireAuth: true},
				component: () => import('./views/pages/admin/Organization.vue'),
			  },
			  {
			  	path: '/admin/role',
			  	name: 'role',
			  	meta:{requireAuth: true},
			  	component: () => import('./views/pages/admin/Role.vue'),
			  },
			  {
			  	path: '/admin/put',
			  	name: 'put',
			  	meta:{requireAuth: true},
			  	component: () => import('./views/pages/admin/Put.vue'),
			  },
	    ],
	  },
	  {
	  	path: '/admin/scoreddetails',
	  	name: 'scoreddetails',
	  	meta:{requireAuth: true},
	  	component: () => import('./views/pages/admin/Scoreddetails.vue'),
	  },
	  {
	  	path: '/admin/scoredtable',
	  	name: 'scoredtable',
	  	meta:{requireAuth: true},
	  	component: () => import('./views/pages/admin/Scoredtable.vue'),
	  },
	  {
	  	path: '/admin/notesdetails',
	  	name: 'notesdetails',
	  	meta:{requireAuth: true},
	  	component: () => import('./views/pages/admin/Notesdetails.vue'),
	  },
	  {
	  	path: '/admin/historydetails',
	  	name: 'historydetails',
	  	meta:{requireAuth: true},
	  	component: () => import('./views/pages/admin/Historydetails.vue'),
	  },
	  {
	  	path: '/admin/historytable',
	  	name: 'historytable',
	  	meta:{requireAuth: true},
	  	component: () => import('./views/pages/admin/Historytable.vue'),
	  },
	  {
	  	path: '/admin/configdetails',
	  	name: 'configdetails',
	  	meta:{requireAuth: true},
	  	component: () => import('./views/pages/admin/Configdetails.vue'),
	  },
	  //登录和注册以及404模块
      {
        path: '/login',
		redirect: '/pages/login',
        component: () => import('@/layouts/full-page/FullPage.vue'),
        children: [
          {
            path: '/pages/login',
            name: 'pageLogin',
            component: () => import('@/views/pages/Login.vue')
          },
		  {
		      path: '/pages/register',
		      name: 'pageRegister',
		      component: () => import('@/views/pages/Register.vue'),
		  },
          {
            path: '/pages/error-404',
            name: 'pageError404',
            component: () => import('@/views/pages/Error404.vue')
          },
        ]
      },
      // 重定向404
      {
        path: '*',
        redirect: '/pages/error-404'
      }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

//路由跳转判断是否登录
router.beforeEach((to, from, next) => {
  // 判断浏览器
  let browserType = navigator.userAgent.toLowerCase();
  let nowDate = new Date();
  let loginState = JSON.parse(localStorage.getItem("loginState"));

  if (browserType.indexOf('msie') >= 0) {
    console.log('ie浏览器');
	alert("为了更好的体验，建议使用谷歌或搜狐浏览器")
  }
  else  {
    if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
      if (loginState&&loginState.expireTime > nowDate.getTime()) { // 判断本地是否存在token
        next()
      } else {
        // 未登录或登录过期,跳转到登陆页面
        next({
          path: '/pages/login'
        })
        return false;
      }
    } else {
		//不需要登录权限直接跳转
        next();
    }
  } 
});

export default router
